import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const TitleText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Highest_Emphasis,
}));

export const DescriptionText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
}));

export const Container = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Secondary,
    display: "flex",
    flexDirection: "column" as const,
}));

export const ContentContainer = styled.div(({ theme }) => ({
    padding: `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.xxSmall} ${theme.spacing.medium}`,
    display: "flex",
    flexDirection: "column" as const,
    gap: theme.spacing.xxSmall,
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const ButtonContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing.medium,
    justifyContent: "space-between",
    gap: theme.spacing.small,
    background: theme.colors[theme.colorMode].background_Primary,
    boxShadow: theme.elevation[theme.colorMode].skim.boxShadow,
}));

export const FlexCta = styled.div({
    flex: "1 1 0",
});
